// Artifact-specific markdown components with enhanced Pre component
import { Highlight } from './Highlight';
import { Plot } from './Plot';
import { Alert } from './Alert';
import { PreviewComponent } from './Preview';
import { Tooltip } from './Tooltip';
import type { CustomComponent } from './types';
import { ArtifactPre } from './ArtifactPre'; // Use the enhanced Pre component
import { GoogleSearch } from './GoogleSearch';
import NetworkGraph from './Network';
import { Image } from './Image'; 
import { Svg } from './SVG';
import { Code } from './Code';
import { ToolConfirmation } from './ToolConfirmation';
import { DynamicUI } from './DynamicUI';
import { Artifact } from './Artifact';

// Artifact-specific components with enhanced Pre for better code display
export const artifactMarkdownComponents: Record<string, CustomComponent> = {
  // Regular lowercase versions
  highlight: Highlight,
  plot: Plot,
  alert: Alert,
  preview: PreviewComponent,
  tooltip: Tooltip,
  pre: ArtifactPre, // Use enhanced Pre for artifacts
  googlesearch: GoogleSearch,
  networkgraph: NetworkGraph,
  img: Image,
  image: Image,
  svg: Svg,
  code: Code,
  toolconfirmation: ToolConfirmation,
  'dynamic-ui': DynamicUI as CustomComponent,
  dynamicui: DynamicUI as CustomComponent,
  artifact: Artifact,

  // PascalCase versions
  Highlight: Highlight,
  Plot: Plot,
  Alert: Alert,
  Preview: PreviewComponent,
  Tooltip: Tooltip,
  Pre: ArtifactPre, // Use enhanced Pre for artifacts
  NetworkGraph: NetworkGraph,
  GoogleSearch: GoogleSearch,
  Img: Image,
  Image: Image,
  Code: Code,
  Svg: Svg,
  ToolConfirmation: ToolConfirmation,
  DynamicUI: DynamicUI as CustomComponent,
  'Dynamic-UI': DynamicUI as CustomComponent,
  Artifact: Artifact,
};

export default artifactMarkdownComponents;